import React from 'react';
import { useTranslation } from 'react-i18next';
import getMarkAsDoneProps from 'utils/asset/getMarkAsDoneProps';
import { MANUAL } from 'utils/asset/markAsDoneModes';
import hasAutoCompleteEnabled from 'utils/asset/hasAutoCompleteEnabled';
import { useMarkMyAssetAsDone, useUnmarkMyAssetAsDone } from 'actions/assets';
import { usePlaylistCompletionContext } from 'components/PlaylistCompletionProvider';
import { useAssetViewerContext } from 'screens/AssetViewerUI/hooks/useAssetViewerContext';
import { jsx as _jsx } from "react/jsx-runtime";
function MarkAsDone(_ref) {
  var Component = _ref.as;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useAssetViewerContex = useAssetViewerContext(),
    asset = _useAssetViewerContex.asset;
  var _usePlaylistCompletio = usePlaylistCompletionContext(),
    setCompletedPlaylists = _usePlaylistCompletio.setCompletedPlaylists;
  var _useMarkMyAssetAsDone = useMarkMyAssetAsDone({
      setCompletedPlaylists: setCompletedPlaylists,
      shouldShowModalImmediately: true
    }),
    markMyAssetAsDone = _useMarkMyAssetAsDone.markMyAssetAsDone;
  var _useUnmarkMyAssetAsDo = useUnmarkMyAssetAsDone({}),
    unmarkMyAssetAsDone = _useUnmarkMyAssetAsDo.unmarkMyAssetAsDone;
  if (!asset || (asset === null || asset === void 0 ? void 0 : asset.type) === 'event') {
    return null;
  }
  var autoCompleteEnabled = hasAutoCompleteEnabled({
    assetType: asset.type,
    markAsDoneMode: asset.markAsDoneMode
  });
  if (autoCompleteEnabled) {
    // We will hide the Mark as done button when autocompletion is enabled
    return null;
  }
  var _getMarkAsDoneProps = getMarkAsDoneProps({
      type: asset.type,
      userContentStatus: asset.userContentStatus,
      userScormAssetStatus: asset.userScormAssetStatus,
      markAsDoneMode: MANUAL
    }),
    buttonTooltip = _getMarkAsDoneProps.buttonTooltip,
    buttonLabel = _getMarkAsDoneProps.buttonLabel,
    buttonIcon = _getMarkAsDoneProps.buttonIcon,
    isActive = _getMarkAsDoneProps.isActive,
    isDisabled = _getMarkAsDoneProps.isDisabled;
  var translatedButtonLabel = t(buttonLabel);
  function toggleMarkAsDone() {
    if (!asset) {
      return;
    }
    if (asset.userContentStatus === 'completed') {
      unmarkMyAssetAsDone({
        id: asset.id,
        playlistId: asset.collection_id
      });
    } else {
      markMyAssetAsDone({
        id: asset.id,
        playlistId: asset.collection_id
      });
    }
  }
  return /*#__PURE__*/_jsx(Component, {
    icon: buttonIcon,
    isActive: isActive,
    disabled: isDisabled,
    title: t(buttonTooltip),
    "aria-label": translatedButtonLabel,
    onClick: toggleMarkAsDone,
    "data-qa": "mark-as-done",
    id: "assetviewer_mark_as_done_button_".concat(asset.id),
    children: translatedButtonLabel
  });
}
export default MarkAsDone;